"use client";

import Image from "next/image";
import { ArrowUpRight } from "lucide-react";
import { usePathname } from "next/navigation";
import { BRAND_NAME, VISIBLE_LOGO_SRC } from "@/lib/brand";
import { Link } from "@/i18n/navigation";
import { cn } from "@/lib/utils";
import { externalLinks, marketingNavigation } from "@/content/lobsterai-site";

export default function SiteHeader() {
  const pathname = usePathname() || "/";

  return (
    <header className="fixed left-0 right-0 top-0 z-50 border-b border-border/60 bg-background/82 backdrop-blur-xl">
      <div className="mx-auto flex min-h-18 max-w-7xl items-center justify-between gap-4 px-4 py-3 sm:px-6 lg:px-8">
        <Link href="/" className="flex items-center gap-3">
          <Image
            src={VISIBLE_LOGO_SRC}
            alt={BRAND_NAME}
            width={36}
            height={36}
            sizes="36px"
            className="rounded-xl border border-border/40 bg-white/80"
            data-brand-logo="header"
            priority
          />
          <div className="leading-none">
            <span className="block text-lg font-semibold tracking-tight text-foreground sm:text-xl">
              {BRAND_NAME}
            </span>
            <span className="hidden text-xs text-muted-foreground sm:block">
              AI Agent 产品官网
            </span>
          </div>
        </Link>

        <nav className="hidden items-center gap-6 lg:flex">
          {marketingNavigation.map((item) => (
            <Link
              key={item.href}
              href={item.href as any}
              className={cn(
                "text-sm transition-colors hover:text-foreground",
                pathname === item.href ? "text-foreground" : "text-muted-foreground"
              )}
            >
              {item.title}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          <a
            href={externalLinks.official}
            target="_blank"
            rel="noreferrer"
            className="hidden rounded-full border border-border/60 px-4 py-2 text-sm text-muted-foreground transition-colors hover:bg-white/80 hover:text-foreground sm:inline-flex"
          >
            官方入口
          </a>
          <a
            href={externalLinks.github}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 rounded-full bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
          >
            GitHub
            <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </div>
    </header>
  );
}
